import { AppState } from '../../../types/store';

export function getRootFolder(state: AppState) {
  return state.rootFolder;
}

export function getCurrentFolder(state: AppState) {
  return state.stash.currentFolder ?? state.rootFolder;
}
